export default theme => {
    return {
        fontSize: 12,
        fontStyle: 'italic',
        lineSpacing: 16,
        fontColor: theme.palette.grey[600]
    }
}